import script from "./MenuUsuario.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuUsuario.vue?vue&type=script&setup=true&lang=js"

import "./MenuUsuario.vue?vue&type=style&index=0&id=66cdefb6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66cdefb6"]])

export default __exports__